import React, { useState } from "react";
import "./ContactPage.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import BannerImage from "../Component/Cpit12.jpg"; // ✅ same banner used on other pages

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile" && !/^\d*$/.test(value)) return;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.name.trim()) tempErrors.name = "Name is required";
    if (!formData.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }
    if (!formData.mobile.trim()) {
      tempErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      tempErrors.mobile = "Mobile number must be 10 digits";
    }
    if (!formData.subject.trim()) tempErrors.subject = "Subject is required";
    if (!formData.message.trim()) tempErrors.message = "Message cannot be empty";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setSuccess("✅ Your message has been sent successfully!");
      setFormData({ name: "", email: "", mobile: "", subject: "", message: "" });
      setErrors({});
      setTimeout(() => setSuccess(""), 4000);
    }
  };

  return (
    <div className="contact-page">
      {/* 🔹 Banner Section */}
      <div className="contact-banner">
        <img src={BannerImage} alt="Contact Banner" className="banner-img" />
        
      </div>

      {/* 🔹 Contact Section */}
      <div className="contact-section position-relative">
        <div className="contact-container">
          {/* Left Info Section */}
          <div className="contact-info">
            <div className="info-box">
              <div className="icon blue">
                <FaMapMarkerAlt />
              </div>
              <div>
                <h4>Our Location</h4>
                <p>
                  Banshi Bazar, Chungi, Near - Honda Agency, Varanasi Main Road,
                  Ghazipur (UP) - 233001
                </p>
              </div>
            </div>

            <div className="info-box">
              <div className="icon red">
                <FaPhoneAlt />
              </div>
              <div>
                <h4>Call Us</h4>
                <p>+91-9919525333</p>
              
              </div>
            </div>

            <div className="info-box">
              <div className="icon yellow">
                <FaEnvelope />
              </div>
              <div>
                <h4>Email Us</h4>
                <p>cpitgzp@gmail.com</p>
              </div>
            </div>

            {/* Google Map */}
            <div className="map-container">
              <iframe
              title="CPIT Map Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.7910759114093!2d83.55698637415036!3d25.578616716148485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3991ff056ecc33a3%3A0x1c10f998c7bfb40b!2sCPIT!5e0!3m2!1sen!2sin!4v1763126353406!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            </div>
          </div>

          {/* Right Form Section */}
          <div className="contact-form">
            <p className="help-text">NEED HELP?</p>
            <h2 className="form-title">Send Us A Message</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <span className="error-text">{errors.name}</span>}

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}

              <input
                type="text"
                name="mobile"
                placeholder="Your Mobile Number"
                maxLength="10"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <span className="error-text">{errors.mobile}</span>}

              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
              />
              {errors.subject && <span className="error-text">{errors.subject}</span>}

              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && <span className="error-text">{errors.message}</span>}

              <button type="submit" className="send-btn">
                Send Message
              </button>
            </form>

            {success && <p className="success-text">{success}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
